import React from 'react';

function SegmentedControl({ label, options, selectedValue, onChange }) {
    return (
        <div className="flex flex-col gap-3 w-full">
            {/* Label elegante acompanhando o padrão do formulário */}
            {label && (
                <label className="font-serif text-xl text-[#528a89]">
                    {label}
                </label>
            )}
            
            {/* Contêiner estilo "Côncavo" (Baixo relevo) */}
            <div className="inline-flex flex-wrap items-center bg-[#FFF5EE]/50 border-2 border-[#dbcdac]/50 rounded-2xl p-1.5 shadow-inner w-full md:w-max">
                {options.map(option => {
                    const isSelected = selectedValue === option.value;
                    
                    return (
                        <button
                            key={option.value}
                            type="button" // Impede submit do form
                            onClick={() => onChange(option.value)}
                            className={`
                                flex-1 md:flex-none px-2 md:px-6 py-2.5 rounded-xl text-xs md:text-sm font-bold uppercase tracking-wider transition-all duration-300
                                ${isSelected 
                                    ? 'bg-[#528a89] text-[#FFF5EE] shadow-md transform scale-[1.03]' // Selecionado: Alto relevo Esmeralda
                                    : 'text-stone-500 hover:text-[#971253] hover:bg-[#dbcdac]/30'    // Inativo: Texto cinza, hover Vinho/Dourado
                                }
                            `}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default SegmentedControl;